import { SearchObject } from "app/common/Model/SearchObject";
import { makeAutoObservable } from "mobx";
import {
    pagingScheduleStaff,
    saveOrUpdateScheduleStaff,
    getScheduleStaffById,
    deleteScheduleStaff,
    saveOrUpdateListSchedule,
    getListStaffSchedule,
} from 'app/services/StaffScheduleService';
import { toast } from "react-toastify";
import { getStaffById } from "app/services/StaffService";

export default class ScheduleStaffStore {
    pageScheduleStaff = null;
    searchScheduleStaff = new SearchObject();
    selectedScheduleStaffList = null;
    selectedScheduleStaff = null;
    selectedScheduleStaffDelete = null;
    openScheduleStaffPopupList = false;
    openScheduleStaffPopup = false;
    openConfirmDeletePopup = false;
    staffId = null;
    staff = null;
    listScheduleStaff = null;
    listScheduleScheduleStaff = [];

    constructor() {
        makeAutoObservable(this);
    }

    setSelectedScheduleStaff = staff => {
        this.selectedScheduleStaff = staff;
    }

    pagingScheduleStaff = () => {
        pagingScheduleStaff(this.searchScheduleStaff)
            .then(({ data }) => {
                this.pageScheduleStaff = data
            })
            .catch(error => {
                toast.error("Lấy dữ liệu không thành công");
            })
    }

    getScheduleStaffById = async (staffId) => {
        let { data } = await getScheduleStaffById(staffId);
        this.selectedScheduleStaff = data;
    }


    getScheduleStaffListById = async (obj) => {
        let { data } = await getListStaffSchedule(obj);
        this.selectedScheduleStaffList = { staff: { id: this.staffId }, listScheduleForStaff: (data || []) };
    }

    setStaffId = async (staffId) => {
        let { data } = await getStaffById(staffId);
        this.staff = data;
        this.staffId = staffId;
    };

    handleOpenCreateUpdatePopupList = async (obj) => {
        if (obj) {
            await this.getScheduleStaffListById(obj);
            this.openScheduleStaffPopupList = true;
        }
        else {
            this.selectedScheduleStaffList = { staff: { id: this.staffId } };
            this.openScheduleStaffPopupList = true;
        }
    }

    handleOpenCreateUpdatePopup = staffId => {
        if (staffId) {
            getScheduleStaffById(staffId).then(({ data }) => {
                this.openScheduleStaffPopup = true;
                this.selectedScheduleStaff = data;
            });
        } else {
            this.selectedScheduleStaff = { staff: { id: this.staffId } };
            this.openScheduleStaffPopup = true;
        }
    }

    handleChangeFormSearch = (searchScheduleStaff) => {
        this.searchScheduleStaff = { ...this.searchScheduleStaff, ...searchScheduleStaff };
        this.pagingScheduleStaff();
    }

    saveOrUpdateScheduleStaff = async staff => {
        return await saveOrUpdateScheduleStaff(staff)
            .then((data) => {
                this.selectedScheduleStaff = null;
                toast.success("Lưu thông tin lịch làm việc của nhân viên thành công!");
                this.pagingScheduleStaff();
                this.handleClosePopup();
            })
            .catch((error) => {
                toast.error("Lưu thông tin lịch làm việc của nhân viên có lỗi");
            });
    }

    saveOrUpdateListSchedule = async staff => {
        return await saveOrUpdateListSchedule(staff)
            .then((data) => {
                this.selectedScheduleStaffList = null;
                toast.success("Lưu thông tin lịch làm việc của nhân viên thành công!");
                this.pagingScheduleStaff();
                this.handleClosePopup();
            })
            .catch((error) => {
                toast.error("Lưu thông tin lịch làm việc của nhân viên có lỗi");
            });
    }

    handleOpenConfirmDeletePopup = (staff) => {
        this.selectedScheduleStaffDelete = staff;
        this.openConfirmDeletePopup = true;
    }

    handleConfirmDelete = () => {
        return deleteScheduleStaff(this?.selectedScheduleStaffDelete?.id)
            .then(() => {
                toast.success("Xóa lịch làm việc của nhân viên thành công!");
                this.selectedScheduleStaffDelete = null;
                this.pagingScheduleStaff();
                this.handleClosePopup();
            })
            .catch((error) => {
                toast.error("Xóa lịch làm việc của nhân viên có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openScheduleStaffPopup = false;
        this.openScheduleStaffPopupList = false;
        this.openConfirmDeletePopup = false;
    }

    handleCloseDelete = () => {
        this.openConfirmDeletePopup = false;
    }

    resetStore = () => {
        this.searchScheduleStaff = new SearchObject();
        this.pageScheduleStaff = null;
        this.selectedScheduleStaff = null;
        this.selectedScheduleStaffList = null;
        this.openScheduleStaffPopup = false;
        this.openScheduleStaffPopupList = false;
        this.openConfirmDeletePopup = false;
    }
}